"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Protocol = void 0;
/**
 * Make a layer of callback proxy, if the message body declares origin source form,
 * when joining the listener will declare that only the source will be processed.
 */
const getProxyCallback = (callback, origin) => {
    return (data, messageId) => {
        // Calibrate source form.
        if (origin && data.origin && origin !== data.origin) {
            return;
        }
        callback(data, messageId);
    };
};
/**
 * Communication protocol base class definition.
 * Define the communication method, will be eventBus,
 * postMessage two communication method inheritance.
 * emit send message
 * on receiving message
 */
class Protocol {
    constructor() {
        /**
         * Communication event map.
         */
        this.eventMap = new Map();
    }
    /**
     * Remove the message listener, clear the entire message type listener without specifying the window listener.
     * @param type message type
     * @param key window ID
     */
    removeListenEvent(type, key) {
        const event = this.eventMap.get(type);
        if (!event) {
            return;
        }
        if (key) {
            event === null || event === void 0 ? true : delete event[key];
            this.eventMap.set(type, event);
            return;
        }
        this.eventMap.delete(type);
    }
    /**
     * When adding a listener, you need to pass in your own form identifier to
     * facilitate receiving data from the specified form.
     * @param type message type
     * @param callback
     * @param key window key, the window identifier for the listener, is stored in the EventMap.
     * @param origin Source window, indicating that only messages window the source form will be processed,
     * or if declared, any person sending a message to this form will be processed.
     */
    on(type, callback, key, origin) {
        let event = this.eventMap.get(type);
        const proxyCallback = getProxyCallback(callback, origin);
        const callbacks = event && event[key] ? [...event[key], proxyCallback] : [proxyCallback];
        if (event) {
            event = Object.assign(Object.assign({}, event), { [key]: callbacks });
        }
        else {
            event = { [key]: callbacks };
        }
        this.eventMap.set(type, event);
    }
    /**
     * Get the callback array.
     * @param type message type
     * @param key window ID
     */
    getCallbacks(type, key) {
        const event = this.eventMap.get(type);
        if (!event) {
            return [];
        }
        if (key) {
            return (event === null || event === void 0 ? void 0 : event[key]) || [];
        }
        return Object.values(event).reduce((total, item) => {
            return [...total, ...item];
        }, []);
    }
    /**
     * Remove all event listeners for the specified window ID.
     * @param key window ID
     */
    removeListenEventByKey(key) {
        this.eventMap.forEach((v) => {
            v === null || v === void 0 ? true : delete v[key];
        });
    }
}
exports.Protocol = Protocol;
